import React, { useState } from 'react';
import './ExportExcel.less';
import Button from '../../../components/envago/Button/Button';
import classNames from 'classnames';
import { JobType } from '../../../redux/jobs/jobs.types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { sharesSelectors } from '../../../redux/shares';
import dayjs from 'dayjs';
import { notificationActions } from '../../../redux/notification';
import { buildLegacyShareWorkbook } from '../../../services/excel/LegacyShareExportBuilder';
import { download } from '../../../services/excel/ExcelExportDownloader';

interface ExportExcelProps {
    jobs: JobType[];
    className?: string;
}

const ExportExcel = ({ jobs, className }: ExportExcelProps) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const createdAccount = useSelector(sharesSelectors.createGetAccount);
    const [isLoading, setIsLoading] = useState(false);

    const handleExport = async () => {
        if (jobs.length === 0) return;
        setIsLoading(true);
        try {
            const blob = await buildLegacyShareWorkbook(jobs);
            const filename = `${dayjs().format('YYYY-MM-DD')} - ${createdAccount?.name ?? 'Aufträge'}.xlsx`;
            await download([{ name: filename, blob }]);
        } catch (e) {
            dispatch(
                notificationActions.showErrorNotification(
                    t('management.accounts.share.exportXlsx.error.title'),
                    t('management.accounts.share.exportXlsx.error.message'),
                ),
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={classNames('export-excel', className)}>
            <Button small ghost onClick={handleExport} className={'block w-full'} disabled={isLoading}>
                {isLoading ? '…' : t('management.accounts.share.exportXlsx.button')}
            </Button>
        </div>
    );
};

export default ExportExcel;
